// src/components/RankingUpdateModal.jsx
// Propose de mettre à jour le classement de la fiche joueur après la saisie d'un match
import React, { useState } from 'react';

/**
 * Props :
 *  - changes : [{ key, name, oldLabel, newLabel }]
 *  - onConfirm(selectedKeys) : met à jour les fiches cochées
 *  - onSkip() : ne rien mettre à jour (le classement reste enregistré dans le match)
 */
export default function RankingUpdateModal({ changes, onConfirm, onSkip }) {
  const [checked, setChecked] = useState(() => Object.fromEntries(changes.map(c => [c.key, true])));
  const th = { textAlign: 'left', padding: '6px 8px', fontSize: '12px', color: '#666', borderBottom: '2px solid #ddd', whiteSpace: 'nowrap' };
  const td = { padding: '8px', fontSize: '13px', borderBottom: '1px solid #eee', verticalAlign: 'middle' };
  const selected = changes.filter(c => checked[c.key]).map(c => c.key);

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px' }}>
      <div style={{ backgroundColor: '#fff', color: '#222', borderRadius: '12px', padding: '16px', width: '100%', maxWidth: '520px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 30px rgba(0,0,0,0.3)', fontFamily: 'Arial, sans-serif' }}>
        <h3 style={{ margin: '0 0 6px', fontSize: '17px' }}>🏆 Mettre à jour le classement ?</h3>
        <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#555' }}>
          Le classement saisi pour ce match diffère de celui de la fiche joueur.
          Mettre la fiche à jour la rendra visible pour les prochains matchs
          (l'ancien classement reste dans l'historique).
        </p>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr><th style={th}></th><th style={th}>Joueur</th><th style={th}>Fiche actuelle</th><th style={th}>Nouveau</th></tr>
            </thead>
            <tbody>
              {changes.map(c => (
                <tr key={c.key}>
                  <td style={td}>
                    <input type="checkbox" checked={!!checked[c.key]} onChange={() => setChecked(prev => ({ ...prev, [c.key]: !prev[c.key] }))} />
                  </td>
                  <td style={td}><strong>{c.name}</strong></td>
                  <td style={td}>{c.oldLabel || '—'}</td>
                  <td style={td}><strong>{c.newLabel}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
          <button type="button" onClick={onSkip}
            style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #bbb', backgroundColor: '#f5f5f5', cursor: 'pointer', fontSize: '14px' }}>
            Non, seulement ce match
          </button>
          <button type="button" onClick={() => onConfirm(selected)} disabled={selected.length === 0}
            style={{ flex: 1, padding: '10px', borderRadius: '8px', border: 'none', backgroundColor: selected.length ? '#1976D2' : '#ccc', color: '#fff', cursor: selected.length ? 'pointer' : 'default', fontSize: '14px', fontWeight: 600 }}>
            Mettre à jour la fiche
          </button>
        </div>
      </div>
    </div>
  );
}